
import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Dropdown, } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import { Toaster } from "../../components/Toaster/Toster";
import Switch from "react-switch";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { UpdateThread } from "../../../services/apis/Thread";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import useDebounce from "../../components/common/Debounce";
import { deleteSupplierApi, getSupplierApi, UpdateSupplierStatus } from "../../../services/apis/Supplier";

const theadData = [
    // { heading: "S.No.", sortingVale: "sno" },
    // { heading: "Id", sortingVale: "_id" },
    // { heading: "Name", sortingVale: "name" },
    // { heading: "Created At", sortingVale: "created_at" },
    // { heading: "Status", sortingVale: "status" },
    // { heading: "Block/Unblock", sortingVale: "block_unblock" },
    // { heading: "Action", sortingVale: "action" },
    { heading: "S.No", sortingVale: "sno" },
    { heading: "Logo", sortingVale: "logo" },
    { heading: "Name", sortingVale: "name" },
    { heading: "Type", sortingVale: "type" },
    { heading: "Start Date", sortingVale: "start_date" },
    { heading: "End Date", sortingVale: "end_date" },
    { heading: "Status", sortingVale: "status" },
    { heading: "Live/Sample", sortingVale: "live_sample" },
    { heading: "Mode", sortingVale: "mode" },
    { heading: "Active/Inactive", sortingVale: "active-inactive" },
];

const ApporvedEvents = () => {
    const [sort, setSortata] = useState(10);
    const [loading, setLoading] = useState(false);
    const [modalCentered, setModalCentered] = useState(false);
    const [logo, setLogo] = useState(null);
    const [data, setData] = useState(
        document.querySelectorAll("#holidayList tbody tr")
    );
    const [formData, setFormData] = useState({
        threadSize: "",
        threadType: "",
        measurementUnit: ""
    });
    const [UpdateCategory, setUpdateCategory] = useState(false);
    const [supplierList, setSupplierList] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [editCategoryId, setEditCategoryId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [iconData, setIconDate] = useState({ complete: false, ind: Number });
    const [error, setErrors] = useState(null); // To manage the error state
    const activePag = useRef(0);
    const [test, settest] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);
    const [showDeleteMdl, setShowDeleteMdl] = useState(false);
    const [deleteTableDataId, setDeleteTableDataId] = useState("");
    const debouncedSearchValue = useDebounce(searchInputValue, 500);

    const navigate = useNavigate()
    const resetForm = () => {
        setFormData({
            threadSize: "",
            threadType: "",
            measurementUnit: ""
        });
        setLogo(null); // Reset the displayed image
        setErrors({}); // Clear errors
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.threadSize) newErrors.threadSize = "ThreadSize is required.";
        // if (!formData.threadType) newErrors.threadType = "ThreadType is required.";
        if (!formData.measurementUnit) newErrors.measurementUnit = "MeasurementUnit is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value, // Dynamically update the field (name, etc.)
        });
        setErrors({
            ...error,
            name: "",
        });
    };

    //   getSubCategoriesApi
    const fetchSupplierList = async (sortValue) => {
        // Set loading to true when the API call starts
        setLoading(true);
        try {
            const res = await getSupplierApi(
                currentPage,
                sort,
                sortValue,
                searchInputValue
            );

            setSupplierList(res?.data);

            setUpdateCategory(false);
        } catch (error) {
            // Catch and handle errors
            console.error("Error fetching cuisines:", error);
            Toaster.error("Failed to load cuisines. Please try again.");
        } finally {
            // Always set loading to false when the API call is done (whether successful or failed)
            setLoading(false);
        }
    }

    useEffect(() => {
        // fetchSupplierList();
    }, [UpdateCategory, currentPage, sort, debouncedSearchValue]);


    const chageData = (frist, sec) => {
        for (var i = 0; i < data.length; ++i) {
            if (i >= frist && i < sec) {
                data[i].classList.remove("d-none");
            } else {
                data[i].classList.add("d-none");
            }
        }
    };

    useEffect(() => {
        setData(document.querySelectorAll("#holidayList tbody tr"));
    }, [test]);

    activePag.current === 0 && chageData(0, sort);

    let paggination = Array(Math.ceil(data.length / sort))
        .fill()
        .map((_, i) => i + 1);

    const onClick = (i) => {
        activePag.current = i;
        chageData(activePag.current * sort, (activePag.current + 1) * sort);
        settest(i);
    };

    function SotingData(name, ind) {

        if (iconData.complete) {
            const sortValue = { value: name, type: "asc" };
            // fetchSupplierList(sortValue);
        } else {
            const sortValue = { value: name, type: "dsc" };
            // fetchSupplierList(sortValue);
        }
    }

    const handleEditThread = async (id) => {
        navigate(`/edit-agency/${id}`)

    };

    const handleDeleteSupplier = (id) => {
        setDeleteTableDataId(id);
        setShowDeleteMdl(true)
    }

    const handleDeleteSubmit = async () => {
        try {
            const res = await deleteSupplierApi(deleteTableDataId);
            //   console.log("response",res);
            if (res.status === 200) {
                Toaster.success(res?.data?.message); // Display success message
                fetchSupplierList();
                setDeleteTableDataId("");
                setShowDeleteMdl(false);
            } else {
                Toaster.error(
                    res?.data?.message || "Something went wrong. Please try again."
                );
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleStatusChange = async (id, currentStatus) => {
        const fdata = {
            status: !currentStatus
        }
        try {
            const res = await UpdateSupplierStatus(id, fdata);
            if (res.status === 200) {
                Toaster.success(res?.data?.message); // Display success message
                fetchSupplierList()
            } else {
                Toaster.error(res?.data?.message || "Something went wrong. Please try again.");
            }
        } catch (err) {
            console.log(err)
        }

        // console.log("newStatus",newStatus)
    };


    const handlePageClick = (selectedPage) => {
        setCurrentPage(selectedPage.selected + 1);
    };

    const handleAddNewBrand = () => {
        setModalCentered(true);
        setIsEdit(false);
        setEditCategoryId("");
        resetForm();
        setSelectedOption(null)
    };


    return (
        <>
            <DeleteWarningMdl title={"table data"} showDeleteMdl={showDeleteMdl} setShowDeleteMdl={setShowDeleteMdl}
                setDeleteTableDataId={setDeleteTableDataId} handleDeleteSubmit={handleDeleteSubmit} />
            <ToastContainer />
            <Loader visible={loading} />
            <PageTitle
                activeMenu={"Events"}
                motherMenu={"Home"}
                motherMenuLink={"/dashboard"}
            />

            <Row>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Events</h4>

                            <button className="btn" style={{ padding: "8px", border: "1px solid #6a73fa", color: "#6a73fa" }} onClick={()=>navigate("/create-my-event")}>Create My Event</button>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <div id="holidayList" className="dataTables_wrapper no-footer">
                                    <div className="justify-content-between d-sm-flex">
                                        <div className="dataTables_length">
                                            <label className="d-flex align-items-center">
                                                Show
                                                <Dropdown className="search-drop">
                                                    <Dropdown.Toggle as="div" className="search-drop-btn">
                                                        {sort}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => setSortata("2")}>
                                                            2
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("5")}>
                                                            5
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("10")}>
                                                            10
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("15")}>
                                                            15
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSortata("20")}>
                                                            20
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                entries
                                            </label>
                                        </div>
                                        <div className="dataTables_filter">
                                            <label>
                                                Search :
                                                <input
                                                    type="search"
                                                    className=""
                                                    placeholder=""
                                                    onChange={(e) => setSearchInputValue(e.target.value)}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <table id="example4" className="display dataTable no-footer w-100">
                                        <thead>
                                            <tr>
                                                {theadData?.map((item, ind) => {
                                                    return (
                                                        <th key={ind}
                                                            onClick={() => {
                                                                SotingData(item?.sortingVale, ind);
                                                                setIconDate((prevState) => ({
                                                                    complete: !prevState.complete,
                                                                    ind: ind,
                                                                }));
                                                            }}>
                                                            {item.heading}
                                                            <span>
                                                                {ind !== iconData.ind && (
                                                                    <i
                                                                        className="fa fa-sort ms-2 fs-12"
                                                                        style={{ opacity: "0.3" }}
                                                                    />
                                                                )}
                                                                {ind === iconData.ind &&
                                                                    (iconData.complete ? (
                                                                        <i
                                                                            className="fa fa-arrow-down ms-2 fs-12"
                                                                            style={{ opacity: "0.7" }}
                                                                        />
                                                                    ) : (
                                                                        <i
                                                                            className="fa fa-arrow-up ms-2 fs-12"
                                                                            style={{ opacity: "0.7" }}
                                                                        />
                                                                    ))}
                                                            </span>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {supplierList?.suppliers?.map((data, ind) => (
                                                <tr key={ind}>
                                                    <td>
                                                        <strong>{ind + 1}</strong>
                                                    </td>
                                                    <td>{data?._id}</td>

                                                    <td className="d-flex align-items-center gap-2">
                                                        <Link to={`/event-view/${data?._id}`}>
                                                            {data?.image ? (
                                                                <img className='select-file-img' src={`https://api.i2rtest.in/v1/images/image/${data?.image}`} alt={data?.name} />
                                                            ) : (
                                                                ""
                                                                // <span>No Image Available</span>
                                                            )} {data?.name}
                                                        </Link>
                                                    </td>



                                                    <td>
                                                        {moment(data?.created_at).format(
                                                            "DD MMM YYYY, h:mm:ss a"
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Switch
                                                            checked={data?.status}
                                                            onChange={() => handleStatusChange(data?._id, data?.status)}
                                                            offColor="#f0f1ff"
                                                            onColor="#6a73fa"
                                                            offHandleColor="#6a73fa"
                                                            onHandleColor="#fff"
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            width={40}  // Adjust width of the switch
                                                            height={20} // Adjust height of the switch
                                                        />
                                                    </td>


                                                    <td>
                                                        <Switch
                                                            checked={data?.block_unblock}
                                                            offColor="#f0f1ff"
                                                            onColor="#6a73fa"
                                                            offHandleColor="#6a73fa"
                                                            onHandleColor="#fff"
                                                            uncheckedIcon={false}
                                                            checkedIcon={false}
                                                            width={40}  // Adjust width of the switch
                                                            height={20} // Adjust height of the switch
                                                        />
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-xs sharp btn-primary me-1"
                                                            onClick={() => handleEditThread(data?._id)}>
                                                            <i className="fa fa-pencil" />
                                                        </button>

                                                        <button className="btn btn-xs sharp btn-danger"
                                                            onClick={() => handleDeleteSupplier(data?._id)}>
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div>
                                        {/* {brandList?.data?.length < brandList?.total && ( */}
                                        <div className="d-sm-flex text-center justify-content-end align-items-center mt-3">
                                            <div className="pagination-container">
                                                <ReactPaginate
                                                    pageCount={Math.ceil(
                                                        supplierList?.totalSuppliers /
                                                        supplierList?.rowsPerPage
                                                    )}
                                                    pageRangeDisplayed={1}
                                                    marginPagesDisplayed={2}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="selected"
                                                    disabledClassName="disabled"
                                                />
                                            </div>
                                        </div>
                                        {/* )} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default ApporvedEvents;
